import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Radium from 'radium';
import onClickOutside from 'react-onclickoutside';
import { Draft, convertToRaw } from '@ublend-npm/th90-editor';
import styleUtils from '@ublend-npm/aulaui-next-web/styles/utils';
import Avatar from '../../../../../../containers/User/Avatar/Avatar';
import { createStateWithMention } from '../../../../../../../utils/editorUtils';
import Editor from '../../../../../common/EditorPlus/EditorPlus.container';
import styles from './style';

@Radium
class CreateCommentFeed extends React.Component {
  constructor(props) {
    super(props);
    this.addCommentRef = React.createRef();

    this.state = {
      editorState: Draft.EditorState.createEmpty(),
      hasFocus: false,
      editorHeight: 108,
      hasContent: false,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleCreateComment = this.handleCreateComment.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);

    this.ignore = () => {};
    this.isUploadModalDisplayed = () => {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.ignore(
      (!nextState.hasFocus && !nextState.hasContent) || nextProps.isInInbox
    );
    return true;
  }

  scrollToBottom() {
    const scrollEditor = (node) => {
      const editorNode = node;
      editorNode.scrollTop = editorNode.scrollHeight;
    };

    const editor = ReactDOM.findDOMNode(this.editor).getElementsByClassName(
      'RichEditor-editor'
    );
    if (editor.length > 0) {
      scrollEditor(editor[0]);
    }
  }

  handleClickOutside() {
    if (
      this.state.hasFocus &&
      !this.state.hasContent &&
      !this.isUploadModalDisplayed()
    ) {
      this.setState({ hasFocus: false });
    }
  }

  handleEditorChange(editorState) {
    if (
      this.editor &&
      this.editor.isEmpty(editorState.getCurrentContent()) &&
      this.state.hasContent
    ) {
      this.setState({ hasContent: false });
    } else if (
      (!this.editor || !this.editor.isEmpty(editorState.getCurrentContent())) &&
      !this.state.hasContent
    ) {
      this.setState({ hasContent: true }, () => {});
    }
    // so that the add block renders correctly
    if (this.editor) this.scrollToBottom();
  }

  handleFocus() {
    if (!this.state.hasFocus) {
      this.setState({ hasFocus: true });
    }
  }

  handleHeightChange(height) {
    this.setState({ editorHeight: height + 54 }, () => {});
  }

  handleCreateComment() {
    const data = {
      postId: this.props.postId,
      content: convertToRaw(this.editor.editor.getEditorState()),
      isQuestion: false,
      isAnonymous: false,
      parent: this.props.parent,
      root: this.props.root,
    };

    const voiceNotification = () => {
      const elem = this.addCommentRef.current;
      elem.innerHTML = `<p>A new comment has been added.</p>`;

      setTimeout(() => {
        elem.innerHTML = '';
      }, 1000);
    };

    this.props
      .createComment(data)
      .then(() => {
        voiceNotification();
      })
      .then(() => {
        this.editor.clear();
        this.setState({
          hasContent: false,
          hasFocus: false,
        });
        this.props.didComment();
      });
  }

  render() {
    const initialEditorState =
      this.props.parentComment &&
      createStateWithMention({ user: this.props.parentComment.user });

    return (
      <div
        onClick={this.handleFocus}
        style={{
          ...styles.container(this.state.editorHeight),
          ...this.props.style,
        }}
      >
        <div style={styles.avatar}>
          <Avatar size={30} user={this.props.user} />
        </div>
        <div style={styles.editor(this.props.root)}>
          <Editor
            id={`post-${this.props.postId}-editor-${
              this.props.parentComment && this.props.parentComment.id
            }`}
            wrappedRef={(r) => {
              this.editor = r;
            }}
            postId={this.props.postId}
            onChange={this.handleEditorChange}
            style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
            type="comment"
            pluginsConfigs={{
              textFormatter: { inverted: true },
              file: {
                ignore: (cb) => {
                  this.ignore = cb;
                },
                isUploadModalDisplayed: (cb) => {
                  this.isUploadModalDisplayed = cb;
                },
              },
            }}
            refreshPlugins
            placeholder="Write a comment..."
            onHeightChange={this.handleHeightChange}
            disabled={this.props.isCreatingComment}
            autoFocus={this.props.autoFocus}
            initialEditorState={initialEditorState}
            paddings={{
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            actionButton={{
              id: `add-comment-to-post-${this.props.postId}`,
              label: 'Comment',
              onClick: this.handleCreateComment,
              showLoader: this.props.isCreatingComment,
              hideWhenBlurred: true,
            }}
          />
        </div>
        <div
          css={[styleUtils.visuallyHidden()]}
          aria-live="polite"
          role="status"
          ref={this.addCommentRef}
        />
      </div>
    );
  }
}

CreateCommentFeed.propTypes = {
  postId: PropTypes.string.isRequired,
  createComment: PropTypes.func,
  isCreatingComment: PropTypes.bool,
  didComment: PropTypes.func,
  isInInbox: PropTypes.bool,
};

export default onClickOutside(CreateCommentFeed);
